import React from 'react';

class Loader extends React.Component {
    render() {
        return (
            <div id='loader' className="text-center">
                <div className="spinner-border text-primary" role="status"></div>
            </div>
        )
    }
}

export default Loader;